// services/chl55.js — декларацията по чл. 55, ал. 1 ЗДДФЛ и чл. 201, ал. 1
// ЗКПО за дължими данъци (чиста сметка, задача 5/6).
//
// Нормативната основа е ДОСЛОВНА от lex.bg (СПРАВКА-ЗКПО-СИДДО.md — свалена
// през браузър; ЗДДФЛ — сверен в задача 4, редакция ДВ, бр. 30 от 27.03.2026):
//   • авансови: чл. 43 (стопанска дейност — брутният доход минус НПР по
//     чл. 29, ал. 1 и осигуровките, ПРОМТ-15), чл. 44 (наем — 10 % НПР по
//     чл. 31, ал. 1), чл. 44а (доходи по чл. 35) — всичките 10 %;
//   • окончателни ЗДДФЛ: чл. 38, ал. 1 (дивиденти/ликвидационни — 5 % по
//     чл. 46, ал. 3, върху брутното ПО РЕШЕНИЕТО — чл. 38, ал. 2), чл. 37
//     (чуждестранни ФЛ — 10 %, БЕЗ нормативни разходи), чл. 38, ал. 12
//     (етажна собственост — 10 %), чл. 38 (награди/застраховки — 10 %, 7 %
//     при „Живот" 15+ г. — чл. 46, ал. 2);
//   • ЗКПО при източника: чл. 194 (дивиденти към чуждестранни ЮЛ и местни
//     ЮЛ-нетърговци — 5 % по чл. 200, ал. 1; срок от РЕШЕНИЕТО — чл. 202,
//     ал. 1) и чл. 195 (доходи на чуждестранни ЮЛ — 10 % по чл. 200, ал. 2;
//     срок от НАЧИСЛЯВАНЕТО — чл. 202, ал. 2). Чл. 200а е ОТМЕНЕН (ДВ
//     105/2014) — никаква ставка 5 % за лихви/роялти; режимът е пълно
//     освобождаване по чл. 195, ал. 6, т. 3 във вр. с ал. 7–12.
//   • СИДДО се прилага само след удостоверяване (ДОПК чл. 135, ал. 2 и
//     чл. 136) и НИКОГА автоматично — ставката се въвежда ръчно.

const { round2 } = require('./totals');
const holidays = require('./holidays');

// ---- Константи с източник ----

// чл. 31, ал. 1 ЗДДФЛ — 10 на сто нормативно признати разходи при наем.
const RENT_EXPENSE_RATE = 0.10;
// чл. 43, ал. 4 / чл. 44 / чл. 44а ЗДДФЛ — авансова ставка 10 на сто.
const ADVANCE_RATE = 0.10;
// чл. 46, ал. 3 ЗДДФЛ и чл. 200, ал. 1 ЗКПО — 5 на сто (дивиденти).
const DIVIDEND_RATE = 0.05;
// чл. 46, ал. 1 ЗДДФЛ и чл. 200, ал. 2 ЗКПО — 10 на сто.
const FINAL_RATE = 0.10;
// чл. 46, ал. 2 ЗДДФЛ — 7 на сто при застраховка „Живот" 15+ години.
const LIFE15_RATE = 0.07;
// чл. 142, ал. 1 ДОПК: текстът на закона (посл. изм. ДВ 69/31.07.2026) още
// гласи „500 000 лв."; еврото се чете по силата на чл. 11, ал. 2 ЗВЕРБ.
const SIDDO_THRESHOLD_BGN = 500000;
// 500 000 ÷ 1,95583 = 255 645,9406 → закръглено по чл. 13 ЗВЕРБ; същото
// число публикува и НАП („до 255 645,94 евро/500 000 лева годишно").
const SIDDO_THRESHOLD_EUR = 255645.94;

// Видът дейност при ред по чл. 43 → нормативно признатите разходи по чл. 29,
// ал. 1 ЗДДФЛ (lex.bg, сверено 02.10.2026, редакция ДВ, бр. 30/27.03.2026):
// „Облагаемият доход от стопанска дейност на физическите лица, които не са
// търговци по смисъла на Търговския закон, се определя, като придобитият
// доход се намалява с разходи за дейността, както следва: 1. с 60 на сто …
// 2. с 40 на сто … 3. с 25 на сто …". Буква „г" е изменена с ДВ, бр. 30 от
// 2026 г., в сила от 01.01.2026 г. — нотариусите са с 40 % от 2026 г.
// Редът е и редът в падащия списък; първият е подразбирането.
const ACTIVITIES = [
  { key: 'free25', label: 'Свободна професия или граждански договор', rate: 25, ref: 'чл. 29, ал. 1, т. 3' },
  { key: 'author40', label: 'Авторски и лицензионни възнаграждения, артисти-изпълнители', rate: 40, ref: 'чл. 29, ал. 1, т. 2, б. „б"' },
  { key: 'craft40', label: 'Занаят (без патентен данък)', rate: 40, ref: 'чл. 29, ал. 1, т. 2, б. „в"' },
  { key: 'lawyer40', label: 'Адвокат или нотариус', rate: 40, ref: 'чл. 29, ал. 1, т. 2, б. „г"' },
  { key: 'agri40', label: 'Селско, горско, ловно и рибно стопанство (без регистрация като земеделски стопанин)', rate: 40, ref: 'чл. 29, ал. 1, т. 2, б. „а"' },
  { key: 'farmer60', label: 'Регистриран земеделски стопанин — непреработена продукция', rate: 60, ref: 'чл. 29, ал. 1, т. 1' },
];
function activityOf(key) {
  return ACTIVITIES.find((a) => a.key === key) || ACTIVITIES[0];
}

// Видовете редове в декларацията (образец 4001, Част IV) с човешки имена.
// НЯМА вид по чл. 200а — той е отменен.
const KIND_LABELS = {
  rent44: 'Наем (чл. 44 ЗДДФЛ, авансов 10 %)',
  other43: 'Стопанска дейност (чл. 43 ЗДДФЛ, авансов 10 %)',
  money44a: 'Доходи по чл. 35 (чл. 44а ЗДДФЛ, авансов 10 %)',
  dividend38: 'Дивидент (чл. 38, ал. 1 ЗДДФЛ, окончателен 5 %)',
  liquidation38: 'Ликвидационен дял (чл. 38, ал. 1 ЗДДФЛ, окончателен 5 %)',
  foreign37: 'Доход на чуждестранно ФЛ (чл. 37 ЗДДФЛ, окончателен 10 %)',
  condo38_12: 'Наем — етажна собственост (чл. 38, ал. 12 ЗДДФЛ, 10 %)',
  prize38: 'Награди / застраховки (чл. 38 ЗДДФЛ, 10 %, „Живот" 15+ г. — 7 %)',
  zkpo194: 'Дивидент/ликв. дял към ЮЛ (чл. 194 ЗКПО, 5 %)',
  zkpo195: 'Доход на чуждестранно ЮЛ (чл. 195 ЗКПО, 10 %)',
};

// Групите за Част IV на образеца: авансови / окончателни ЗДДФЛ / ЗКПО.
const KIND_GROUP = {
  rent44: 'advance', other43: 'advance', money44a: 'advance',
  dividend38: 'final', liquidation38: 'final', foreign37: 'final',
  condo38_12: 'final', prize38: 'final',
  zkpo194: 'zkpo', zkpo195: 'zkpo',
};

function dfmt(iso) {
  const p = String(iso || '').split('-');
  return p.length === 3 ? p[2] + '.' + p[1] + '.' + p[0] : String(iso || '');
}

// Краят на месеца, следващ тримесечието (чл. 56, ал. 1 ЗДДФЛ; чл. 201,
// ал. 1 ЗКПО — декларира се в срока за внасяне).
function quarterDeadlineBase(quarter, year) {
  if (quarter === 1) return year + '-04-30';
  if (quarter === 2) return year + '-07-31';
  if (quarter === 3) return year + '-10-31';
  return (year + 1) + '-01-31';
}
function quarterOf(iso) {
  const m = Number(String(iso || '').slice(5, 7));
  return m ? Math.floor((m - 1) / 3) + 1 : null;
}

// Срок + изместване при неприсъствен ден (чл. 22, ал. 7 ДОПК; броенето на
// празници е само в services/holidays.js). Връща { base, date, shifted }.
function deadline(quarter, year, overrides) {
  const base = quarterDeadlineBase(quarter, year);
  if (holidays.isWorkingDay(base, overrides)) return { base, date: base, shifted: false };
  return { base, date: holidays.nextWorkingDay(base, overrides), shifted: true };
}

// Един ред от декларацията → { ...ред, rate, tax, group, notes, excluded }.
function computeRow(row, ctx) {
  const kind = String(row.kind || '');
  const amount = round2(row.amount);
  const notes = [];
  const out = { kind, label: KIND_LABELS[kind] || kind, amount, group: KIND_GROUP[kind] || 'final', notes, excluded: false };

  // Брутното → НПР → (осигуровки) → основа: полетата се връщат готови, за да
  // не смятат екранът и PDF-ът сами. При останалите видове сумата Е основата.
  out.base = amount;
  out.nprRate = null;
  out.npr = null;

  if (kind === 'rent44' || kind === 'other43') {
    out.gross = amount;
    out.rate = 10;
    if (kind === 'rent44') {
      // чл. 31, ал. 1: 10 % НПР; чл. 44 — 10 % върху облагаемия доход.
      // Осигуровки тук не се приспадат (чл. 44, ал. 1 — калкулатор „Наем").
      out.nprRate = 10;
      out.npr = round2(amount * RENT_EXPENSE_RATE);
      out.contributions = 0;
      out.base = round2(amount - out.npr);
    } else {
      // чл. 29, ал. 1 — НПР по вида дейност; чл. 43, ал. 1 — „разликата между
      // облагаемия доход и вноските, които самоосигуряващото се лице е
      // задължено да прави за своя сметка за месеците на тримесечието …, а ако
      // лицето не е самоосигуряващо се - между облагаемия доход и удържаните
      // задължителни осигурителни вноски"; чл. 43, ал. 3 — „разликата по
      // ал. 1 се умножи по данъчна ставка 10 на сто".
      const act = activityOf(row.activity);
      const c = Number(row.contributions);
      out.activity = act.key;
      out.label = act.label + ' (чл. 43 ЗДДФЛ, авансов 10 %)';
      out.nprRate = act.rate;
      out.npr = round2(amount * act.rate / 100);
      out.contributions = Number.isFinite(c) && c > 0 ? round2(c) : 0;
      const taxable = round2(amount - out.npr);
      out.base = round2(Math.max(0, taxable - out.contributions));
      if (out.contributions > taxable) notes.push('Осигуровките надвишават облагаемия доход — основата е 0.');
      if (act.key === 'lawyer40' && ctx.year <= 2025) notes.push('За 2025 г. нотариусите са с 25 % — изберете „Свободна професия".');
    }
    out.tax = round2(out.base * ADVANCE_RATE);
  } else if (kind === 'money44a') {
    out.rate = 10;
    out.tax = round2(amount * ADVANCE_RATE);
  } else if (kind === 'dividend38' || kind === 'liquidation38') {
    // чл. 38, ал. 2: основата е брутната сума ПО РЕШЕНИЕТО; чл. 65, ал. 2:
    // срокът тече от тримесечието на РЕШЕНИЕТО, не от плащането.
    out.rate = 5;
    out.tax = round2(amount * DIVIDEND_RATE);
    if (row.decisionDate) {
      const q = quarterOf(row.decisionDate);
      const y = Number(String(row.decisionDate).slice(0, 4));
      const d = deadline(q, y, ctx.overrides);
      out.dueDateBase = d.base;
      out.dueDate = d.date;
      notes.push('Срокът тече от тримесечието на РЕШЕНИЕТО за разпределяне (' + dfmt(row.decisionDate) + ') — чл. 65, ал. 2 ЗДДФЛ.');
      if (q !== ctx.quarter || y !== ctx.year) {
        notes.push('Решението е от ' + q + '-о тримесечие на ' + y + ' г. — различно от декларираното: редът се декларира за тримесечието на решението.');
      }
    } else {
      notes.push('Въведете датата на решението — срокът и тримесечието тръгват от нея (чл. 65, ал. 2).');
    }
    if (kind === 'liquidation38') notes.push('Основата при ликвидационен дял е разликата над документално доказаната цена на придобиване (чл. 33, ал. 8 — въведете вече сметнатата основа).');
  } else if (kind === 'foreign37') {
    out.rate = 10;
    out.tax = round2(amount * FINAL_RATE);
    notes.push('Окончателен данък върху БРУТНИЯ доход — без нормативни разходи (чл. 37 ЗДДФЛ).');
  } else if (kind === 'condo38_12') {
    out.rate = 10;
    out.tax = round2(amount * FINAL_RATE);
  } else if (kind === 'prize38') {
    const life = !!row.life15;
    out.rate = life ? 7 : 10;
    out.tax = round2(amount * (life ? LIFE15_RATE : FINAL_RATE));
    if (life) notes.push('7 % — суми след изтичане на застраховка „Живот" 15+ години (чл. 46, ал. 2).');
  } else if (kind === 'zkpo194') {
    // чл. 194, ал. 1: само чуждестранни ЮЛ и местни ЮЛ-НЕтърговци (вкл.
    // общини). Местно ЮЛ-търговец е ИЗВЪН обхвата — редът се изключва.
    if (row.recipient === 'local_trader') {
      out.excluded = true;
      out.rate = 0;
      out.tax = 0;
      notes.push('Дивидент към местно ЮЛ-ТЪРГОВЕЦ не се облага по чл. 194 ЗКПО (ал. 1 обхваща само чуждестранни ЮЛ и местни ЮЛ, които не са търговци) — редът не влиза в декларацията.');
    } else {
      out.rate = 5;
      out.tax = round2(amount * DIVIDEND_RATE);
      if (row.recipient === 'eu_eea') {
        out.excluded = true;
        out.tax = 0;
        notes.push('Чл. 194, ал. 3, т. 3: дивидент към ЮЛ от ЕС/ЕИП не се облага (освен при скрито разпределение) — редът не влиза.');
      }
      if (row.decisionDate) {
        const q = quarterOf(row.decisionDate);
        const y = Number(String(row.decisionDate).slice(0, 4));
        const d = deadline(q, y, ctx.overrides);
        out.dueDateBase = d.base;
        out.dueDate = d.date;
        notes.push('Срокът тече от тримесечието на РЕШЕНИЕТО (чл. 202, ал. 1 ЗКПО).');
      }
    }
  } else if (kind === 'zkpo195') {
    if (row.isAdvance) {
      out.rate = 0;
      out.tax = 0;
      notes.push('Авансово плащане — не подлежи на облагане с данък при източника (чл. 195, ал. 5 ЗКПО); данъкът се дължи при начисляването на дохода.');
    } else if (row.euExempt && !row.exemptBroken) {
      out.rate = 0;
      out.tax = 0;
      notes.push('Освободено по чл. 195, ал. 6, т. 3 във вр. с ал. 7–12 ЗКПО: лихви/авторски и лицензионни между свързани лица от ЕС (≥ 25 % участие, непрекъснато 2 години). Чл. 200а е ОТМЕНЕН — преференциална СТАВКА няма, режимът е пълно освобождаване.');
    } else if (row.euExempt && row.exemptBroken) {
      out.rate = 10;
      out.tax = round2(amount * FINAL_RATE);
      notes.push('Прекъснато 2-годишно участие преди изтичане на срока: дължат се пълните 10 % (чл. 195, ал. 9) плюс ЛИХВА ЗА ПРОСРОЧИЕ от датата, на която данъкът е следвало да бъде внесен.');
    } else if (row.siddoRate != null && row.siddoRate !== '') {
      // СИДДО — САМО с ръчно въведена ставка, никога автоматично.
      const rate = round2(row.siddoRate);
      out.rate = rate;
      out.tax = round2(amount * rate / 100);
      notes.push('Приложена СИДДО ставка ' + String(rate).replace('.', ',') + ' % — след удостоверяване на основанията (чл. 135, ал. 2 и чл. 136 ДОПК: местно лице, притежател на дохода — чл. 136а, без МСД в България). Проверете ставката в текста на спогодбата.');
    } else {
      out.rate = 10;
      out.tax = round2(amount * FINAL_RATE);
      notes.push('10 % по чл. 200, ал. 2 ЗКПО. При СИДДО въведете ставката РЪЧНО — справочникът е само ориентир.');
      if (row.siddoCountry) notes.push('Избрана държава: ' + row.siddoCountry + ' — ставка по СИДДО не е въведена, важи пълната.');
    }
    notes.push('Срокът тече от тримесечието на НАЧИСЛЯВАНЕТО на дохода (чл. 202, ал. 2 ЗКПО), не от плащането.');
  } else {
    out.rate = 0;
    out.tax = 0;
    out.excluded = true;
    notes.push('Непознат вид ред — не влиза в декларацията.');
  }

  // Четвърто тримесечие — авансов данък НЕ се удържа/внася (същото правило
  // като калкулатора „Наем", services/rent.js). Основата, НПР и осигуровките
  // остават видими — нулира се само данъкът.
  //   чл. 67, ал. 2: „Не се внася авансов данък по чл. 43, ал. 6 и чл. 44,
  //   ал. 3 за доходи, придобити през четвъртото тримесечие на данъчната
  //   година." — за чл. 44а няма аналог при получателя, затова не се пипа.
  //   чл. 65, ал. 13 (дословно в src/calculators/rent.js) — платецът не
  //   удържа по чл. 43, ал. 4, чл. 44, ал. 4 и чл. 44а, ал. 1, освен при
  //   писмено декларирано желание на лицето.
  if (Number(ctx.quarter) === 4 && (kind === 'rent44' || kind === 'other43' || kind === 'money44a')) {
    if (ctx.role === 'recipient') {
      if (kind !== 'money44a') {
        out.tax = 0;
        notes.push('Четвърто тримесечие — лицето не внася авансов данък, без изключение (чл. 67, ал. 2 ЗДДФЛ).');
      }
    } else if (row.wantsQ4) {
      notes.push('Четвърто тримесечие — лицето писмено е поискало удържане (чл. 65, ал. 13 ЗДДФЛ): данъкът се удържа и декларира, срокът е 31 януари.');
    } else {
      out.tax = 0;
      notes.push('Четвърто тримесечие — данък не се удържа и не се внася, освен ако лицето писмено декларира желание за удържане (чл. 65, ал. 13 ЗДДФЛ); тогава отбележете това на реда.');
    }
  }
  return out;
}

// Цялата декларация за едно тримесечие.
function chl55Declaration(input) {
  const inp = input || {};
  const quarter = Math.min(4, Math.max(1, Number(inp.quarter) || 1));
  const year = Number(inp.year) || new Date().getFullYear();
  const role = inp.role === 'recipient' ? 'recipient' : 'payer';
  const currency = year >= 2026 ? 'EUR' : 'BGN';
  const ctx = { quarter, year, role, overrides: inp.overrides };
  const notes = [];

  const rows = (Array.isArray(inp.rows) ? inp.rows : []).map((r) => computeRow(r, ctx));

  const totals = { advance: 0, final: 0, zkpo: 0, total: 0 };
  for (const r of rows) {
    if (r.excluded) continue;
    totals[r.group] = round2(totals[r.group] + r.tax);
  }
  totals.total = round2(totals.advance + totals.final + totals.zkpo);

  const d = deadline(quarter, year, inp.overrides);
  if (d.shifted) {
    notes.push('Срокът ' + dfmt(d.base) + ' е неприсъствен ден — мести се на следващия работен (' + dfmt(d.date) + ') по чл. 22, ал. 7 ДОПК. Проверете при подаване.');
  }
  if (currency === 'BGN') {
    notes.push('Период до 31.12.2025 г. — декларацията е в ЛЕВОВЕ, макар срокът да е през 2026 г.; плащането към НАП е в евро след превалутиране по чл. 12–13 ЗВЕРБ (разяснение на НАП).');
  }
  if (quarter === 4) {
    notes.push('За IV тримесечие се декларират окончателните данъци и данъкът при източника; авансов данък по ЗДДФЛ — само при писмено декларирано желание за удържане (чл. 65, ал. 13).');
  }
  if (role === 'recipient') {
    notes.push('Декларацията се подава от ПОЛУЧАТЕЛЯ на дохода: по ЗДДФЛ — когато платецът не е задължен да удържа (чл. 55, ал. 2, освен по чл. 67, ал. 4); по ЗКПО — в случаите по чл. 201, ал. 3 и чл. 195, ал. 3.');
  }
  notes.push('Декларацията се подава в срока за внасяне (чл. 56, ал. 1 ЗДДФЛ; чл. 201, ал. 1 ЗКПО), само по електронен път за предприятия и СОЛ (чл. 56, ал. 2).');

  return {
    quarter, year, role, currency, rows, totals,
    dueDate: d.date, dueDateBase: d.base, notes,
  };
}

// Прагът по чл. 142, ал. 1 ДОПК за опростения ред по СИДДО. Сумата е ОБЩИЯТ
// годишен доход, начислен на чуждестранното лице.
function siddoThresholdCheck(annualAmount, currency) {
  const amount = round2(annualAmount);
  const threshold = currency === 'BGN' ? SIDDO_THRESHOLD_BGN : SIDDO_THRESHOLD_EUR;
  const simplified = amount <= threshold;
  const both = '500 000 лв. / 255 645,94 € (законовият текст още гласи левове; еврото се чете по чл. 11, ал. 2 ЗВЕРБ)';
  const note = simplified
    ? 'До ' + both + ' годишно: основанията се удостоверяват ПРЕД ПЛАТЕЦА, искане по чл. 137 не се подава (чл. 142, ал. 1 ДОПК). Не забравяйте: платецът декларира изплатените доходи и облекченията до 31 март на следващата година (чл. 142, ал. 5).'
    : 'Над ' + both + ' годишно: основанията се удостоверяват с ИСКАНЕ по чл. 137 ДОПК пред НАП (становище до 60 дни; непроизнасянето се смята за наличие на основания — чл. 141, ал. 2).';
  return { simplified, thresholdBgn: SIDDO_THRESHOLD_BGN, thresholdEur: SIDDO_THRESHOLD_EUR, note };
}

module.exports = {
  chl55Declaration,
  ACTIVITIES,
  siddoThresholdCheck,
  KIND_LABELS,
  KIND_GROUP,
  SIDDO_THRESHOLD_BGN,
  SIDDO_THRESHOLD_EUR,
};
